"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CarsSearch;
const react_1 = __importStar(require("react"));
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const CarModalButtons_1 = require("./Modals/CarModalButtons");
const CarsController_1 = require("./CarsController");
const CarFilterBody_1 = require("./CarFilterBody");
const adminTableCells_1 = require("../adminTableCells");
/**
 * Lista samochodów służbowych.
 *
 * Bez usuwania: kilometrówka trzyma historię w arkuszach Google powiązanych przez
 * identyfikator arkusza, a nie przez klucz obcy. Skasowanie auta rozspójniłoby
 * arkusz z systemem po cichu. Wycofanie z użytku to wyłączenie flagi „Aktywny”.
 *
 * Suma colMd wynosi 11, bo ostatnią kolumnę (1 z 12) zajmują przyciski akcji.
 * Przekroczenie tej sumy zrzuca je do kolejnego wiersza.
 */
function CarsSearch({ title }) {
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    return (react_1.default.createElement(FilterableTable_1.default, { id: "cars", title: title, FilterBodyComponent: CarFilterBody_1.CarsFilterBody, tableStructure: [
            {
                header: "Marka",
                renderTdBody: (car) => react_1.default.createElement(adminTableCells_1.TextCell, { value: car.brand }),
                colMd: 2,
            },
            {
                header: "Model",
                renderTdBody: (car) => react_1.default.createElement(adminTableCells_1.TextCell, { value: car.model }),
                colMd: 2,
            },
            {
                header: "Nr rej.",
                renderTdBody: (car) => react_1.default.createElement(adminTableCells_1.TextCell, { value: car.licensePlateNumber }),
                colMd: 1,
            },
            {
                header: "Aktywny",
                renderTdBody: (car) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: car.isActive }),
                colMd: 1,
            },
            {
                header: "W kilometrówce",
                renderTdBody: (car) => (react_1.default.createElement(adminTableCells_1.BoolCell, { value: !!car.isActive && !!car.mileageSpreadsheetId && car.mileageSheetGid != null })),
                colMd: 2,
            },
            {
                header: "Uwagi",
                renderTdBody: (car) => react_1.default.createElement(adminTableCells_1.OptionalTextCell, { value: car.comment }),
                colMd: 3,
            },
        ], AddNewButtonComponents: [CarModalButtons_1.CarAddNewModalButton], EditButtonComponent: CarModalButtons_1.CarEditModalButton, isDeletable: false, repository: CarsController_1.carsRepository, searchOnMount: true }));
}
